import { render, staticRenderFns } from "./set-goal-step.vue?vue&type=template&id=3274f254"
import script from "./set-goal-step.vue?vue&type=script&lang=js"
export * from "./set-goal-step.vue?vue&type=script&lang=js"
import style0 from "./set-goal-step.vue?vue&type=style&index=0&id=3274f254&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports